export const fileTypeSortingColumns = [
    'name',
    'createdAt',
    'createdBy',
];
